// extracted by mini-css-extract-plugin
module.exports = {"buttons":"templateDownloadButton_buttons__i-mSt","downloadButton":"templateDownloadButton_downloadButton__2OOQ_"};